export default "__VITE_ASSET__b53989f5__"